import React from 'react'
import * as S from './styles'
import { ReactComponent as PendencyIcon } from 'presentation/assets/icons/pendency-icon.svg'
import moment from 'moment'
import { convertNameToTitleCase } from 'presentation/hospital/layouts/SurgicalOrder/functions'
import RMarkdown from 'presentation/hospital/components/RMarkdown'

export type ProcedurePendencyCardProps = {
  variant?: 'orange' | 'purple' | 'green'
  selected?: boolean
  title?: string
  description?: string
  lastMessageInfo?: string
  responsible?: string
  createdAt?: string
  message?: string
  status?: string
  authorLastMessage?: string
  dateLastMessage?: string
}

export const ProcedurePendencyCard = ({
  variant,
  selected,
  title,
  description,
  responsible,
  createdAt,
  message,
  status,
  authorLastMessage,
  dateLastMessage
}: ProcedurePendencyCardProps) => {
  return (
    <S.CardContainer variant={variant} selected={selected}>
      <div className="header_container">
        <label>
          <PendencyIcon />
          {title}
        </label>

        <div className="status_tag">
          <span>{status}</span>
        </div>
      </div>

      <S.LineDivider />

      <h2>{description}</h2>

      {message && (
        <div className="comment_container">
          <span>
            <RMarkdown rawText={message} />
          </span>
        </div>
      )}

      <div className="pendency_info">
        <div>
          <strong>Última mensagem</strong>
          <p>
            {convertNameToTitleCase(authorLastMessage || '')}
            <span> em </span>
            {moment.utc(dateLastMessage).locale('pt-br').format('DD [de] MMMM')}
            <span> às </span>
            {moment.utc(dateLastMessage).locale('pt-br').format('LT')}
          </p>
        </div>
        <div>
          <strong>Criação da pendência</strong>
          <p>
            {responsible}
            <span> em </span>
            {moment.utc(createdAt).locale('pt-br').format('DD [de] MMMM')}
            <span> às </span>
            {moment.utc(createdAt).locale('pt-br').format('LT')}
          </p>
        </div>
      </div>
    </S.CardContainer>
  )
}
